import SchemaAdapter from "./Schema";

export default SchemaAdapter;
